import {
  ADD_OFFER_TRACKER,
  DELETE_OFFER,
  DELETE_OFFER_TRACKER,
  GET_OFFER_BY_ID,
  GET_OFFER_DATA,
  GET_OFFER_HISTORY_LIST,
  GET_OFFER_TRACKER_LIST,
  GET_OFFERS,
  GET_OFFERS_FOR_CLIENT,
  GET_TRACKER_OFFER_PROFILE,
  GET_TRACKERS,
  HIDE_OFFER_DATA_LOADER,
  HIDE_OFFER_TRACKER_LIST_LOADER,
  HIDE_TRACKERS_LOADER,
  OFFER_STATE_INIT,
  POST_OFFER,
  SET_ERROR_TRACKER_OFFER_PROFILE,
  SET_OFFER,
  SET_OFFER_DATA,
  SET_OFFER_HISTORY_LIST,
  SET_OFFER_TRACKER_LIST,
  SET_OFFERS,
  SET_OFFERS_FOR_CLIENT,
  SET_TRACKER_OFFER_PROFILE,
  SET_TRACKERS,
  SHOW_OFFER_DATA_LOADER,
  SHOW_OFFER_TRACKER_LIST_LOADER,
  SHOW_TRACKERS_LOADER,
  UPDATE_OFFER,
  UPDATE_TRACKER_OFFER_PROFILE,
  SHOW_OFFER_LOADER,
  HIDE_OFFER_LOADER,
  ADD_OFFER_HISTORY,
  SET_OFFER_HISTORY_ITEM,
  UPDATE_OFFER_STATUS,
  DELETE_OFFER_HISTORY,
  GET_OFFER_WITH_REGULAR_MATCHING,
  GET_OFFERS_WITH_REGULAR_MATCHING,
  SET_OFFERS_RENT_FOR_CLIENT,
  HIDE_OFFERS_WITH_REGULAR_MATCHING_LOADER,
  SHOW_OFFERS_WITH_REGULAR_MATCHING_LOADER,
  SET_OFFERS_WITH_REGULAR_MATCHING,
  GET_OFFERS_BY_CONTRACT, 
  SET_OFFERS_BY_CONTRACT, 
  OFFERS_BY_CONTRACT_LOADER
} from "./actionTypes";

export const getOffers = data => ({
  type: GET_OFFERS,
  payload: { data },
});

export const setOffers = data => ({
  type: SET_OFFERS,
  payload: data,
});

export const getOfferData = data => ({
  type: GET_OFFER_DATA,
  payload: data,
});

export const setOfferData = payload => ({
  type: SET_OFFER_DATA,
  payload,
});

export const showOfferLoader = () => ({
  type: SHOW_OFFER_LOADER,
});

export const hideOfferLoader = () => ({
  type: HIDE_OFFER_LOADER,
});

export const showOfferDataLoader = () => ({
  type: SHOW_OFFER_DATA_LOADER,
});

export const hideOfferDataLoader = () => ({
  type: HIDE_OFFER_DATA_LOADER,
});

export const hideTrackersLoader = () => ({
  type: HIDE_TRACKERS_LOADER,
});

export const showTrackersLoader = () => ({
  type: SHOW_TRACKERS_LOADER,
});

export const getTrackers = data => ({
  type: GET_TRACKERS,
  payload: data,
});

export const setTrackers = data => ({
  type: SET_TRACKERS,
  payload: data,
});

export const postOffer = ({ data, history }) => ({
  type: POST_OFFER,
  payload: { data, history },
});

export const updateOffer = (id, data, callback) => ({
  type: UPDATE_OFFER,
  payload: { id, data, callback },
});

export const updateOfferStatus = (id, ids, data, callback) => ({
  type: UPDATE_OFFER_STATUS,
  payload: { id, ids, data, callback },
});

export const deleteOffer = (id, onRedirectToClient) => ({
  type: DELETE_OFFER,
  payload: { id, onRedirectToClient },
});

export const setOffer = data => ({
  type: SET_OFFER,
  payload: data,
});

export const getOfferById = (id, history, need_current_offer) => ({
  type: GET_OFFER_BY_ID,
  payload: { id, history, need_current_offer },
});

export const getOffersForClient = (data, id) => ({
  type: GET_OFFERS_FOR_CLIENT,
  payload: { id, data },
});

export const setOffersForClient = data => ({
  type: SET_OFFERS_FOR_CLIENT,
  payload: data,
});

export const setOffersRentForClient = data => ({
  type: SET_OFFERS_RENT_FOR_CLIENT,
  payload: data,
});

export const addOfferHistory = data => ({
  type: ADD_OFFER_HISTORY,
  payload: { data },
});

export const deleteOfferHistory = id => ({
  type: DELETE_OFFER_HISTORY,
  payload: id,
});

export const getOfferHistoryList = id => ({
  type: GET_OFFER_HISTORY_LIST,
  payload: id,
});

export const setOfferHistoryList = data => ({
  type: SET_OFFER_HISTORY_LIST,
  payload: data,
});

export const setOfferHistoryItem = payload => ({
  type: SET_OFFER_HISTORY_ITEM,
  payload,
});

export const getOfferTrackersList = (data, id) => ({
  type: GET_OFFER_TRACKER_LIST,
  payload: data,
  id,
});

export const offerStateInit = () => ({
  type: OFFER_STATE_INIT,
});

export const setOfferTrackersList = data => ({
  type: SET_OFFER_TRACKER_LIST,
  payload: data,
});

export const showOfferTrackersListLoader = () => ({
  type: SHOW_OFFER_TRACKER_LIST_LOADER,
});

export const hideOfferTrackersListListLoader = () => ({
  type: HIDE_OFFER_TRACKER_LIST_LOADER,
});

export const addOfferTracker = (tracker = {}, data = {}) => ({
  type: ADD_OFFER_TRACKER,
  payload: { tracker, data },
});

export const deleteOfferTracker = (id, data = {}, offer_id) => ({
  type: DELETE_OFFER_TRACKER,
  payload: { id, data, offer_id },
});

export const getTrackerOfferProfile = id => ({
  type: GET_TRACKER_OFFER_PROFILE,
  payload: id,
});

export const setTrackerOfferProfile = payload => ({
  type: SET_TRACKER_OFFER_PROFILE,
  payload,
});

export const updateTrackerOfferProfile = (id, tracker = {}, data = {}) => ({
  type: UPDATE_TRACKER_OFFER_PROFILE,
  payload: { id, tracker, data },
});

export const setErrorTrackerOfferProfile = payload => ({
  type: SET_ERROR_TRACKER_OFFER_PROFILE,
  payload,
});

export const getOffersWithRegularMatching = payload => ({
  type: GET_OFFERS_WITH_REGULAR_MATCHING,
  payload,
});

export const setOffersWithRegularMatching = payload => ({
  type: SET_OFFERS_WITH_REGULAR_MATCHING,
  payload,
});

export const showOffersWithRegularMatchingLoader = () => ({
  type: SHOW_OFFERS_WITH_REGULAR_MATCHING_LOADER,
});

export const hideOffersWithRegularMatchingLoader = () => ({
  type: HIDE_OFFERS_WITH_REGULAR_MATCHING_LOADER,
});

export const getOffersByContract = payload => ({
  type: GET_OFFERS_BY_CONTRACT,
  payload,
});

export const setOffersByContract = payload => ({
  type: SET_OFFERS_BY_CONTRACT,
  payload,
});

export const showOffersByContractLoader = () => ({
  type: OFFERS_BY_CONTRACT_LOADER, 
});